import { Helmet } from "react-helmet";
const PrivacyPolicy = () => {
  return (
    <>
      <Helmet>
        <title>Privacy Policy | Hirestar.io</title>
        <meta
          name="description"
          content="Understand how Hirestar.io collects, uses, and protects your data. Our Privacy Policy details our commitment to your security and transparency in background verification."
        ></meta>
        <meta
          name="keywords"
          content="Data Protection, Information Privacy,Terms of Service,Privacy Statement"
        />
        <meta property="og:site_name" content="HireStar.io" />
        <link
          rel="canonical"
          href={`https://hirestar.io${window.location.pathname}`}
        />
        <meta property="og:locale" content="en_US" />
        <meta property="og:title" content="Privacy Policy | Hirestar.io" />
        <meta
          property="og:description"
          content="Understand how Hirestar.io collects, uses, and protects your data. Our Privacy Policy details our commitment to your security and transparency in background verification."
        />
        <meta
          property="og:url"
          content="https://hirestar.io/connect-with-sales"
        />
        <meta property="og:type" content="website" />
        {/* <meta
          property="og:image"
          content="https://hirestarorg.blr1.digitaloceanspaces.com/Hirestar-Landing-Page/assets/About_Us_img/about_girl.png"
        /> */}

        <meta name="robots" content="index, follow" />
        <meta property="og:image:type" content="image/png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Privacy Policy | Hirestar.io" />
        <meta
          name="twitter:description"
          content="Understand how Hirestar.io collects, uses, and protects your data. Our Privacy Policy details our commitment to your security and transparency in background verification."
        />
        {/* <meta
          name="twitter:image"
          content="https://hirestarorg.blr1.digitaloceanspaces.com/Hirestar-Landing-Page/assets/About_Us_img/about_girl.png"
        /> */}
      </Helmet>

      <div className="min-h-screen  py-12 px-6 md:px-10 ">
        <div className="max-w-7xl border  mx-auto  rounded-lg p-4 md:p-8 lg:p-8 mt-12 shadow-md">
          <h1 className="text-3xl font-bold text-gray-900 mb-6 text-center">
            Privacy Policy
          </h1>
          <p className="text-gray-600 mb-4">
            We at Hirestar, prioritize protecting and securing your Personal
            Information and are committed to providing you with a safe, seamless
            and secure experience while accessing or using our Services. Our
            Privacy Policy helps you understand our practices regarding the
            collection, use, maintenance and disclosure of your Personal
            Information. We respect the privacy of your Personal Information and
            undertake to ensure that the information that we have access to will
            be treated only in a manner described in this Privacy Policy.
          </p>
          <p className="text-gray-600 mb-4">
            Whenever the Privacy Policy mentions the terms "Hirestar" or "we" or
            "us" or "our", it refers to DappLogix Software Pvt Ltd, which is
            responsible for your Personal Information under this Privacy Policy.
            Unless otherwise defined herein, capitalized terms shall have the
            meanings assigned to such terms in the Hirestar Terms of Service,
            which is available at <b>hirestar.io</b> and which is incorporated
            into this Privacy Policy by reference.
          </p>
          <p className="text-gray-600 mb-4">
            We conduct our business in compliance with applicable laws and shall
            collect, use and process your Personal Information only in
            accordance with applicable data protection and security laws,
            regulations and guidelines.
          </p>
          <p className="text-gray-600 mb-8 font-bold uppercase">
            WE URGE YOU TO THOROUGHLY READ THIS PRIVACY POLICY. BY ACCESSING AND
            USING THE SERVICES OR BY SUBMITTING PERSONAL INFORMATION THROUGH THE
            SERVICES, YOU EXPRESSLY CONSENT TO THE PROCESSING OF YOUR PERSONAL
            INFORMATION ACCORDING TO THIS PRIVACY POLICY AND HAVE REPRESENTED
            YOUR AGREEMENT TO THIS PRIVACY POLICY, (WHICH MAY BE REVISED FROM
            TIME TO TIME) AND TO BE BOUND BY ITS TERMS. IF YOU DO NOT AGREE WITH
            THE PRACTICES DESCRIBED IN THIS PRIVACY POLICY, PLEASE DO NOT
            PROVIDE US WITH YOUR PERSONAL INFORMATION OR INTERACT WITH THE
            SERVICES.
          </p>

          <div className="mb-8">
            <h2 className="text-lg font-semibold text-gray-900   ">
              1. Scope of the Policy
            </h2>
            <div className="mt-2 rounded-lg text-gray-700">
              <p className="mb-4">
                a. This Privacy Policy applies to our Services the Personal
                Information collected by us through the Services. To make our
                Services accessible to you and to administer and manage your
                relationship with us, we will necessarily need to collect, use,
                disclose and/or process your Personal Information, to which you
                consent by agreeing to this Privacy Policy. For the purpose of
                this Privacy Policy the term Personal Information means any
                information relating to an identified or identifiable natural
                person; an identifiable natural person is one who can be
                identified, directly or indirectly, in particular by reference
                to an identifier such as a name, an identification number,
                location data, online identifier or to one or more factors
                specific to the physical, physiological, genetic, mental,
                economic, cultural or social identity of that person.
              </p>
              <p className="mb-4">
                b. Our Privacy Policy applies to all clients, visitors, users,
                candidates and others who access our Services directly,
                indirectly or otherwise ("users", "you", "your"). If you are a
                corporate entity or an organization, references to the terms
                "you" and "your" shall include your employees, representatives,
                agents.
              </p>
              <p className="mb-4">
                c. Our privacy and security practices in connection with the
                access and use of our Services are governed by the Terms of
                Service Agreement, which is a binding contract between you and
                us.
              </p>
              <p className="mb-4">
                d. By agreeing to this Privacy Policy, you give your express and
                unequivocal consent to us to procure your data or the Personal
                Information of others requested by you, from educational
                institutions, organizations, third party service providers,
                public databases etc. You hereby also agree and warrant that you
                have obtained requisite express consent from all the persons
                whose Personal Information you provide to us through the
                Services.
              </p>
              <p>
                e. Our Privacy Policy does not apply to services offered by
                other companies, third party service providers or individuals,
                including products or sites that may be displayed to you in
                search results or other sites linked from our Services. You
                should consider the privacy practices of those third-parties
                carefully.
              </p>
            </div>
          </div>

          <div className="mb-8">
            <h2 className="text-lg font-semibold text-gray-900  rounded-lg">
              2. Information we collect
            </h2>
            <div className="mt-2  text-gray-700">
              <p className="mb-4">
                We collect information that you provide us directly or
                automatically when you use the Services. The collection of your
                Personal Information or any Personal Information provided by you
                shall be strictly restricted to what is necessary for the
                purpose of fulfilling the purposes identified herein below. We
                may collect and retain the following information from and about
                you or any other person as requested by you if you interact with
                us through the Services:
              </p>
              <p className="mb-4">
                a. The information that you voluntarily provide when you access
                or use our Services and which include but shall not be limited
                your name, company name, email etc. and the name, age, date of
                birth, address, PAN, employment history, educational
                qualification, professional experience, claims, court cases,
                criminal background, judgments, character, personal reputation,
                and such other background checks of any persons that you provide
                to us through the Services.
              </p>
              <p className="mb-4">
                b. We may also collect information about the pages/links you
                visit / access on our site, the number of times you access each
                page, search queries and open posts, your Internet Protocol (IP)
                address, web browser type, web browser version, internet service
                provider, site trends, location, referring URL, timestamp
                information, app packages, app names, urls, email address, poll
                inputs and the operating system that your computer or device is
                running etc. The purpose of the information is for analyzing
                trends, administering the site, tracking users' movement on the
                website, and gathering demographic information. We treat such
                data in the same manner as we treat Personal Information
                voluntarily provided by you, under this Privacy Policy.
              </p>
              <p className="mb-4">
                c. We may also collect any information entered by you when you
                interact with the Services or our personnel for any purpose,
                including but not limited to reporting a problem with or
                difficulty using our Services or for providing feedback. When
                you affirmatively provide an email address and tick the non-pre
                populated tick box available at the time of providing the email
                address, you opt in to receive emails from us as permitted by
                law. To opt out of receiving emails from us, you may either use
                the "Unsubscribe" button at the end of our emails or send us an
                opt-out request at <b>admin@hirestar.io</b>. Please note that
                you cannot opt-out of receiving certain administrative or legal
                notices from us.
              </p>
              <p>
                d. Any information that we ask for and may collect from various
                sources, which may include but are not limited to, information
                you voluntarily provide us at any events, seminars, conferences,
                talks, promotions, surveys organised by us, and/or information
                we collect when you submit web forms on our Services or if you
                use interactive features of our Services.
              </p>
            </div>
          </div>

          <div className="mb-8">
            <h2 className="text-lg font-semibold text-gray-900  rounded-lg">
              3. How we use the information
            </h2>
            <div className="mt-2  text-gray-700">
              <p className="mb-4">
                The Personal Information provided to us or that we collect from
                you through other sources is used to provide the Services and to
                fulfill our obligations under our agreement with you and/or to
                comply with the statutory legal obligations. The information
                collected may be used by us for various purposes including,
                without limitation:
              </p>
              <ul className="list-disc pl-6 space-y-2 mb-4">
                <li>
                  i. To provide you with information that may be requested by
                  you from time to time;
                </li>
                <li>ii. To contact you regarding our Services;</li>
                <li>iii. To register an account on our Services</li>
                <li>
                  iV. To carry out pre employment, educational, previous
                  employment and criminal background verifications.
                </li>
                <li>
                  V. To procure information from organizations, educational
                  institutions and public databases.
                </li>
                <li>vi. To send job offers through the Service.</li>
                <li>vii. To contact individuals in case of job offers.</li>
                <li>
                  viii. To track status of the job offers and background
                  verification checks.
                </li>
                <li>ix. To provide assistance as and when requested.</li>
                <li>
                  X. To send you updates and confirmations of Services availed;
                </li>
                <li>
                  xi. To enhance other information we have about you to help us
                  better understand you, determine your interests and provide
                  you with more relevant and compelling services;
                </li>
                <li>xii. To maintain, operate and improve the Services;</li>
                <li>
                  xiii. Contact you to ensure that the information we have in
                  our records is accurate or when in need of additional
                  information in connection with Services;
                </li>
                <li>
                  XiV. To facilitate communication and improve our business
                  relationship with you and to respond to your queries, requests
                  or complaints and/or resolve any issues and disputes which may
                  arise in connection with any dealings with us;
                </li>
                <li>
                  XV. To monitor and identify areas of our Services in which
                  improvement may be needed;
                </li>
                <li>
                  xvi. To investigate, detect and prevent any unauthorized
                  access to the Services and prohibited or illegal activity or
                  omission or misconduct;
                </li>
                <li>
                  xvii. We may use information for the security of our company,
                  customers, employees and/or our Services.
                </li>
                <li>
                  xviii. Sending technical notices, updates, security alerts,
                  and support and administrative messages;
                </li>
                <li>
                  xix. To comply with any request or direction or lawfully
                  disclose information required by any applicable law,
                  regulation, direction, court order, bylaw, guidance, circular
                  or code applicable to us.
                </li>
                <li>
                  XX. To undertake marketing research, analysis of customer
                  patterns and choices, statistical and trend analysis in
                  relation to our services.
                </li>
                <li>
                  xxi. Monitoring and analyzing usage, and activities in
                  connection with the Websites and Services and for marketing or
                  advertising purposes;
                </li>
                <li>
                  xxii. To contact you about changes to our site and Service,
                  new Service, features we offer, or other information we think
                  you might find valuable, as well as to provide or enhance
                  features of our Site and Service.
                </li>
              </ul>
              <p>
                We shall not use your Personal Information for any purpose, than
                for what it is collected. We may use your Personal Information
                for purposes not stated herein above but only with your express
                or implied prior consent for such use.
              </p>
            </div>
          </div>

          <div className="mb-8">
            <h2 className="text-lg font-semibold text-gray-900 rounded-lg">
              4. Sharing your Information
            </h2>
            <div className="mt-2  text-gray-700">
              <p className="mb-4">
                We do not rent, sell, share or disclose your Personal
                Information to third-parties without your consent. We may share
                your information with the following parties/entities for the
                purposes of fulfilling our contractual obligations with you:
              </p>
              <p className="mb-4">
                a. Internal processors. We may disclose your information to our
                employees, directors, and individuals acting as our agents and
                contractors. We shall ensure that our internal processors use
                the information strictly in accordance with this Privacy Policy.
              </p>
              <p className="mb-4">
                b. External processors. We may share your information with our
                third party service providers as needed to carry out the
                performance and functionality of the Services, conduct
                background verification checks, prepare reports, fulfill your
                requests, support our business, host, manage and maintain our
                Services, develop applications for us, carry on analytics, store
                and backup our data or provide customer support. These external
                processors shall not store, retain, or use your information, for
                marketing or any other purpose except for processing the
                transaction or providing a service on our behalf. We may share
                aggregated, non-personally identifiable information publicly and
                with our partners - like publishers, advertisers or connected
                sites. However we are not responsible for any breach of security
                or for any actions of any third Parties that receive your
                Personal Information.
              </p>
              <p className="mb-4">
                c. User/client/customers, who use our Services (including
                services like background checks, and other consumer reports).
              </p>
              <p className="mb-4">
                d. We may share information from or about you with subsidiaries,
                joint ventures, or other companies under common control, in
                which case they are legally bound to honor this Privacy Policy.
                If we are acquired by or merged with another entity, if
                substantially all of our assets are transferred to another
                company, or as part of a bankruptcy proceeding, we may transfer
                the information we have collected about you to the other
                company.
              </p>
              <p>
                e. We will share your Personal Information with companies,
                organizations or individuals outside of Hirestar if we have a
                good-faith belief that access, use, preservation or disclosure
                of the information is reasonably necessary to, (i) Meet any
                applicable law, regulation, legal process or enforceable
                governmental request; (ii) Enforce applicable Terms of Service,
                including investigation of potential violation; iii) Detect,
                prevent, or otherwise address fraud, security or technical
                issues or (iv) Protect against harm to the rights, property or
                safety of Hirestar, our users or the public as required or
                permitted by law.
              </p>
            </div>
          </div>

          <div className="mb-8">
            <h2 className="text-lg font-semibold text-gray-900  rounded-lg">
              5. Storage and Transfer of your Personal Information
            </h2>
            <div className="mt-2  text-gray-700">
              <p>
                The information collected by us will be stored in secure servers
                located, including in India. You hereby consent to the storage
                of your Personal Information in our servers located in India. We
                do not transfer your Personal Information with third parties,
                unless it is necessary to fulfill our obligations to you and as
                permitted by law. We shall make appropriate arrangements to
                ensure that your data is processed in a secure manner and in
                compliance with applicable data protection laws, specific to
                your country.
              </p>
            </div>
          </div>

          <div className="mb-8">
            <h2 className="text-lg font-semibold text-gray-900  rounded-lg">
              6. Cookies And Tracking Technologies
            </h2>
            <div className="mt-2  text-gray-700">
              <p className="mb-4">
                a. We may collect Personal Information with the help of tracking
                tools like browser cookies. The term "cookies" refers to small
                pieces of information stored on the hard drive of your computer
                or computer while you view a site. The primary objective of
                cookies is recordkeeping and uniquely identifying your browser.
              </p>
              <p className="mb-4">
                b. We use cookies to improve the quality of our Services.
                Cookies help us to tailor our Services to best suit your
                preferences and provide you with ease and convenience while
                accessing our Services. Not all data collected from cookies is
                Personal Information, such information is collected for creating
                a better user experience.
              </p>
              <p className="mb-4">
                c. We use traffic log cookies to identify which pages are being
                used. This helps us analyze data about web page traffic and
                improve our Services in order to tailor it to the needs of the
                User. We only use this information for statistical analysis
                purposes and then the data is removed from the system.
              </p>
              <p>
                d. Neither we nor any other Third Parties performing services on
                our behalf shall use cookies to automatically retrieve any
                Personal Information from your computer. If you do not wish to
                receive cookies, you may configure your browser either to notify
                you when you receive a cookie or to disable cookies. It is
                pertinent you understand that should you choose to disable
                cookies, some functions of Services may not work properly or may
                not work at all.
              </p>
            </div>
          </div>

          <div className="mb-8">
            <h2 className="text-lg font-semibold text-gray-900  rounded-lg">
              7. Accuracy of information
            </h2>
            <div className="mt-2  text-gray-700">
              <p>
                Since most of the information collected by us is directly from
                the user/candidates, we cannot guarantee that the information
                will be accurate. Any information collected by us through a
                third party source, such third party is responsible for the
                accuracy of the information.
              </p>
            </div>
          </div>

          <div className="mb-8">
            <h2 className="text-lg font-semibold text-gray-900  rounded-lg">
              8. Retention of Information
            </h2>
            <div className="mt-2  text-gray-700">
              <p>
                We may retain information, including in order to comply with the
                law, prevent fraud, collect any fees owed, resolve any disputes,
                troubleshoot problems, assist with any investigations of any
                User, to enforce our Terms of Service, and/or for any other
                purposes otherwise permitted by law that we deem necessary in
                our sole discretion. However, once a background check report has
                been submitted to the user, Hirestar shall have no control over
                user's use and retention of such information. When we have no
                ongoing legitimate business, operational, legal or other
                statutory need to process your Personal Information, we will
                either anonymize it and will securely store your Personal
                Information and will not be visible to the front end.
              </p>
            </div>
          </div>

          <div className="mb-8">
            <h2 className="text-lg font-semibold text-gray-900 rounded-lg">
              9. Personal Information of Minors
            </h2>
            <div className="mt-2  text-gray-700">
              <p>
                We do not consciously collect Personal Information from minors
                (i.e. individuals under 18 years of age and/or any such age as
                required in your country for you to be authorised to use our
                Services). If you are a minor, please do not submit any Personal
                Information to us. If you are a parent or a guardian we strongly
                recommend you to supervise the online activity of your minor
                children and ensure that your children do not disclose any
                Personal Information. If you believe that we may have
                unknowingly collected Personal Information from minors without
                parental consent, kindly Contact us at the contact details
                provided herein below, so that we may adopt appropriate measures
                to address the issue promptly and remove the information.
              </p>
            </div>
          </div>

          <div className="mb-8">
            <h2 className="text-lg font-semibold text-gray-900 ">
              10. Links To Other Sites
            </h2>
            <div className="mt-2  text-gray-700">
              <p>
                Our Services may contain links to other third party websites. If
                you choose to click on one of these links you may be taken to
                websites we do not control. This Privacy Policy does not apply
                to the privacy practices of those websites. We do not control
                and assume no responsibility for the content, security or
                privacy policies and practices on those websites. We request you
                to read the privacy policies of those sites to determine how
                they collect, process, use, disclose and protect your Personal
                Information.
              </p>
            </div>
          </div>

          <div className="mb-8">
            <h2 className="text-lg font-semibold text-gray-900  rounded-lg">
              11. Security
            </h2>
            <div className="mt-2  text-gray-700">
              <p className="mb-4">
                a. We use strict security measures to ensure the security,
                integrity and privacy of Personal Information and to protect
                your Personal Information against unauthorized access or
                unauthorized alteration, disclosure or destruction
              </p>
              <p className="mb-4">
                b. We have put in place reasonable and necessary organizational
                and physical measures and are implementing and updating
                appropriate administrative, technical, organizational and
                physical security measures of commercially acceptable security
                standards to help protect your information against unauthorized
                access, loss, destruction, use, alteration or disclosure of any
                information we store. Some of the safeguards we use to protect
                your information are firewalls and information access controls.
              </p>
              <p className="mb-4">
                c. Although we have used our best efforts to ensure the security
                of Personal Information, we cannot guarantee you that Personal
                Information will never be disclosed in a manner that is
                inconsistent with this Privacy Policy.
              </p>
              <p className="mb-4">
                d. All our employees and intermediaries, who have access to and
                process your Personal Information, are trained in handling
                Personal Information and are required to respect the
                confidentiality of your Personal Information.
              </p>
              <p>
                e. You agree that any security breaches beyond our reasonable
                control are at your sole risk and discretion, we cannot and do
                not accept responsibility for the same. If you have any
                questions about our security arrangements please contact us at
                the contact details provided herein under.
              </p>
            </div>
          </div>

          <div className="mb-8">
            <h2 className="text-lg font-semibold text-gray-900  rounded-lg">
              12. Privacy Policy Updates
            </h2>
            <div className="mt-2  text-gray-700">
              <p>
                We reserve the right to modify, revise and/or amend this Privacy
                Policy from time to time so as to reflect our current privacy
                practices. We may change the Privacy Policy without sending a
                prior notice of the same. We will post an updated copy/ new
                version on our Services. Any changes to this notice will come
                into effect on posting to this page. You are requested to check
                our website periodically for such updates. If you access our
                Services after a notice of change has been published on our
                page, you hereby provide us your consent to the changed terms.
              </p>
            </div>
          </div>

          <div className="mb-8">
            <h2 className="text-lg font-semibold text-gray-900  rounded-lg">
              13. Dispute Resolution
            </h2>
            <div className="mt-2  text-gray-700">
              <p>
                If you believe that we have not adhered to this Privacy Policy
                you may convey the same to us by contacting us in the manner
                mentioned below. In your email, please describe in as much
                detail as possible ways in which you believe the Privacy Policy
                has not been complied with. In addition to the foregoing, any
                disputes arising under this Privacy Policy shall be governed by
                the laws of India.
              </p>
            </div>
          </div>

          <div className="mb-8">
            <h2 className="text-lg font-semibold text-gray-900 rounded-lg">
              14. Contact Us
            </h2>
            <div className="mt-2  text-gray-700">
              <p>
                If you have questions/complaints/feedback regarding this Policy
                and /or want to report any violations of this Policy, please
                feel free to reach out to our Grievance Officer Mr. Praful
                Vinayak on:{" "}
                <a
                  href="mailto:admin@hirestar.io"
                  className="text-blue-600 hover:underline"
                >
                  admin@hirestar.io
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;
